/*footer accordian start*/
/* jQuery(document).ready(function(){   
	var windowSize = $(window).width();
	if (windowSize < 768) { 
		jQuery('.block-bottom-one h4').click(function() {
		jQuery(this).parent().siblings('.block-bottom-one').find('h4').removeClass('activate');
		jQuery(this).parent().siblings('.block-bottom-one').find('.footer-ms').slideUp(250);
		jQuery(this).next('.footer-ms').slideToggle(250);
		jQuery(this).next('.footer-ms').children('.block-bottom-one').find('.footer-ms').slideUp(250);
		jQuery(this).next('.footer-ms').children('.block-bottom-one').find('h4').removeClass('activate');
		jQuery(this).toggleClass('activate');
		return false;
		}); 
	};		
	});  */

/*footer accordian end*/	


/*global mobile slider*/
function mobileSlider(){

	var windowSize = $(window).width();
	if (windowSize < 768) {

		//cycle mobile slider elements
		$('.mobile-slider').each(function(index, element) {

			//only proceed with activation if it hasn't been done before (parent doesn't have a backup)
			if ($(element).parent().find('.mobile-slider-backup').length === 0) {

				//create desktop backup and append to parent
				var $backup = $(element).clone();
				$backup.removeClass('mobile-slider').addClass('mobile-slider-backup')
				$('<div class="mobile-slider-revert" style="display: none;"></div>')
					.append($backup)
					.appendTo($(element).parent())
				;

				//activate slider
				$(element).owlCarousel({
					loop: true,
					margin: 10,
					responsiveClass: true,
					items: 1,
					autoplay: true,
					autoplayTimeout: 3000,
					smartSpeed: 800
				});
			}
		})

	} else {
		//viewport is now desktop size: revert to desktop (backup) slider if needed.
		$('.mobile-slider').each(function (index, element) {
			if ($(element).parent().find('.mobile-slider-backup').length > 0) {
				let $backup = $(element).parent().find('.mobile-slider-backup');
				$backup.removeClass('mobile-slider-backup').addClass('mobile-slider');
				$(element).replaceWith($backup);
			}
		})
	}
}

$(document).ready(function() {

	//initial call
	mobileSlider();

	//on-resize call, with throttle
	var resize_mobileslider_timeout;
	$(window).on('resize',
		function(){
			clearTimeout(resize_mobileslider_timeout);
			resize_mobileslider_timeout = setTimeout(mobileSlider, 250);
		}
	);
});

/*global mobile slider end*/


/*mobile menu accordian*/
var windowSize = $(window).width();
var $dropdownToggle = $('.dropdown-toggle');
$dropdownToggle.each(function() {
	var toggleLabel = $(this).data('label');
	if (typeof toggleLabel == 'undefined') {
		toggleLabel = 'Dropdown Toggle';
	}
	$(this).after('<span class="child-trigger"><i></i></span>');
	$(this)
		.siblings('.child-trigger')
		.wrap('<button class="panel-heading" aria-label="' + toggleLabel + '"></button>');
});

$('#sideLeftPushy .panel-heading').click(function (e){
	$('.active').slideUp(350).removeClass('active');
	$('.activate').removeClass('activate');

	if ($(this).siblings('.dropdown-menu').css('display') != 'block') {
		$(this)
			.siblings('.dropdown-menu')
			.addClass('active')
			.slideDown('slow');
		$(this).addClass('activate');
	}
});


	
////****tocuh event for mobile when click on first time get enable dropdown and redirect on second click****////
 $(function() {
  
  $("#sideLeftPushy .dropdown-toggle").on('tap', function(e) { // Mobile browsers only
      e.preventDefault(); // Stop from following link
	 var togDiv = $(this).parent().find("ul.dropdown-menu")[0];	
	 if($(togDiv).is(":visible") == true) {
		 window.location.href = $(this).attr("href");
	 }
	 else {
		$('.active').slideUp(350).removeClass('active');
		$('.activate').removeClass('activate');
		$(togDiv).addClass('active').slideDown('slow');
		$(togDiv).prev().addClass('activate');
	 }
  });
});
	

function mobileScrollCheck() {
	var windowSize = $(window).width();
	if (windowSize < 768) {
		window.mobileScrollInitialized = true;
      //Keep track of last scroll
      var lastScroll = 0;
      $(window).scroll(function(event){
          //Sets the current scroll position
          var st = $(this).scrollTop();
		  //alert(st+'--'+lastScroll);
          //Determines up-or-down scrolling
          if(st==0){
			  //alert(1);
			  $(".mobile-view").removeClass("headroom-not-top");
			  $(".mobile-view").addClass("headroom-top");
		  } 
		  else if (st > lastScroll){
             //Replace this with your function call for downward-scrolling
             $(".mobile-view").addClass("headroom-not-top headroom-unpinned");
			 $(".mobile-view").removeClass("headroom-pinned headroom-top");
          }
          else {
             //Replace this with your function call for upward-scrolling
             $(".mobile-view").addClass("headroom-pinned");
             $(".mobile-view").removeClass("headroom-unpinned");
          }
          //Updates scroll position
          lastScroll = st;		  

      });
	};
};

$(document).ready(function() {

	//initial call
	mobileScrollCheck();

	//on-resize call, with throttle, if the mobile scroll hasn't been initialized yet.
	var resize_scrollinit_timeout;
	$(window).on('resize',
		function(){
			if (window.mobileScrollInitialized != true) {
				clearTimeout(resize_scrollinit_timeout);
				resize_scrollinit_timeout = setTimeout(mobileScrollCheck, 250);
			}
		}
	);
});